// src/components/ListSearch.jsx
//
// A labelled search box (the .search-input-wrap look used across the app) for
// filtering a list in the browser, with an optional slot for filter controls
// beside it. Controlled; the parent owns the query and the filters.
import React from 'react';
import Icon from './Icon';

export default function ListSearch({ id, label, placeholder, value, onChange, filters }) {
  return (
    <div className="toolbar" style={{ marginBottom: 16 }}>
      <div className="search-input-wrap" style={{ maxWidth: 'none', flex: '1 1 240px' }}>
        <label className="mlist-sr-only" htmlFor={id}>{label}</label>
        <span className="search-icon"><Icon name="search" size={15} /></span>
        <input id={id} className="search-input" type="search" maxLength={100}
          placeholder={placeholder} value={value}
          onChange={e => onChange(e.target.value.slice(0, 100))} />
      </div>
      {filters}
    </div>
  );
}
